import { MapBounds, MapCenter, MarkerType } from 'entities/common';

function getCenter(bounds: MapBounds): MapCenter {
  return {
    lat: ((bounds?.minLat || 0) + (bounds?.maxLat || 0)) / 2,
    lng: ((bounds?.minLng || 0) + (bounds?.maxLng || 0)) / 2,
  };
}

function createBounds(bounds: MapBounds): google.maps.LatLngBounds {
  const sw = new google.maps.LatLng(bounds.minLat || 0, bounds.minLng);
  const ne = new google.maps.LatLng(bounds.maxLat || 0, bounds.maxLng);

  return new google.maps.LatLngBounds(sw, ne);
}

const getCoordsKey = (lat: number, lng: number) => {
  const latString = String(Math.floor(lat));
  const lngString = String(Math.floor(lng));
  const latKey = `${latString.slice(0, latString.length - 1)}${
    Number(latString[latString.length - 1]) < 5 ? 0 : 5
  }`;
  const lngKey = `${lngString.slice(0, lngString.length - 1)}${
    Number(lngString[lngString.length - 1]) < 5 ? 0 : 5
  }`;

  return { latKey, lngKey };
};

const getMapSize = (data: MarkerType[]): MapBounds => {
  const mapSize: MapBounds = {
    minLng: undefined,
    maxLng: undefined,
    minLat: undefined,
    maxLat: undefined,
  };
  const neighbor: { [key: string]: number } = {};
  let maxCountKey: string | null = null;

  const coords = data?.map(({ location }) => {
    const lat = location?.lat;
    const lng = location?.lng;

    const { latKey, lngKey } = getCoordsKey(lat, lng);

    neighbor[`${latKey}, ${lngKey}`] = neighbor[`${latKey}, ${lngKey}`]
      ? neighbor[`${latKey}, ${lngKey}`] + 1
      : 1;

    return {
      lat,
      lng,
    };
  });

  Object.keys(neighbor).forEach((key) => {
    if (!maxCountKey || neighbor[key] > neighbor[maxCountKey || '']) {
      maxCountKey = key;
    }
  });

  coords.forEach(({ lat, lng }) => {
    const { latKey, lngKey } = getCoordsKey(lat, lng);

    if (
      `${Number(latKey)}, ${Number(lngKey)}` === maxCountKey ||
      `${Number(latKey) + 5}, ${Number(lngKey)}` === maxCountKey ||
      `${Number(latKey) - 5}, ${Number(lngKey)}` === maxCountKey ||
      `${Number(latKey)}, ${Number(lngKey) + 5}` === maxCountKey ||
      `${Number(latKey)}, ${Number(lngKey) - 5}` === maxCountKey ||
      `${Number(latKey) + 5}, ${Number(lngKey) + 5}` === maxCountKey ||
      `${Number(latKey) - 5}, ${Number(lngKey) + 5}` === maxCountKey ||
      `${Number(latKey) + 5}, ${Number(lngKey) - 5}` === maxCountKey ||
      `${Number(latKey) - 5}, ${Number(lngKey) - 5}` === maxCountKey
    ) {
      if (!mapSize.maxLat || mapSize.maxLat < lat) {
        mapSize.maxLat = lat;
      }

      if (!mapSize.minLat || mapSize.minLat > lat) {
        mapSize.minLat = lat;
      }

      if (!mapSize.maxLng || mapSize.maxLng < lng) {
        mapSize.maxLng = lng;
      }

      if (!mapSize.minLng || mapSize.minLng > lng) {
        mapSize.minLng = lng;
      }
    }
  });

  return mapSize;
};

export default {
  getCenter,
  getMapSize,
  getCoordsKey,
  createBounds,
};
